import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import ContentForm, { ContentFormData } from '../components/forms/ContentForm';

export default function WriteArticlePage() {
  const navigate = useNavigate();
  const { theme } = useTheme();

  const handleSubmit = (data: ContentFormData) => {
    // In a real app, this would be an API call
    console.log('Publishing article:', data);
    navigate('/articles');
  };

  return (
    <div className="py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className={`text-3xl font-bold mb-8 ${
          theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
        }`}>
          Write Article
        </h1>
        <ContentForm type="article" onSubmit={handleSubmit} />
      </div>
    </div>
  );
}